export default __webpack_public_path__ + "static/media/ButtonBuy.b226753f.png";